"use strict";

var dd = require("../core");

require("../platform"), module.exports = dd;